import Methods from '../Methods';
import Transport, { ITransport } from '../Transports';
import IQueryService from './IQueryService';
import IQueryNumericCounterOptionsRequest from '../Requests/IQueryNumericCounterUnitsRequest';

const baseUri = '/api/v1/numeric-counters/units';

class NumericCounterUnitsService implements IQueryService<IQueryNumericCounterOptionsRequest, string> {
    private _transport: ITransport;

    constructor(transport: ITransport) {
        this._transport = transport;
    }

    public queryAsync(request?: IQueryNumericCounterOptionsRequest): Promise<string[]> {
        return this._transport.invokeAsync<IQueryNumericCounterOptionsRequest, string[]>(Methods.Get, baseUri, request);
    }
}

const service = Object.freeze(new NumericCounterUnitsService(Transport));
export default service;
